<template>
  <!-- Widgets builder -->
  <main class="wrapper-content w-100">
    <h1>Generador de Widgets</h1>
    <LmComponentLoading v-if="isLoading" fixed />
    <b-row>
      <b-col cols="6">
        <section id="widget-builder-section">
          <h3 class="mb-4">Configuración</h3>
          <header class="d-flex justify-content-between align-items-center bg-primary text-white px-3 py-1 shadow rounded-lg">
            <h4>{{ widget.name || 'Nombre del widget' }}</h4>
          </header>
          <div class="p-4 border border-top-0 rounded-lg">
            <b-row>
              <LmSelect
                class="col-12"
                label="Tipo de widget"
                v-model="widgetTypesSelected"
                :options="widgetTypesOptions"
                @input="onSelectWidgetType"
              />
            </b-row>
            <Component
              :is="widgetType"
              v-model="widget"
              :isOnEditMode="isOnEditMode"
            />
          </div>
          <b-row class="mt-4">
            <LmButton
              class="col-auto"
              type="button"
              buttonClass="btn-secondary"
              :value="$t('cancel')"
              @click="onCancel"
            />
            <LmButton
              class="col-auto"
              type="button"
              buttonClass="btn-primary"
              :value="$t('save')"
              @click="onSave"
            />
            <LmButton
              v-if="isOnEditMode"
              class="col-auto"
              type="button"
              action="delete"
              buttonClass="btn-danger"
              :value="$t('delete')"
              @click="onDelete"
            />
          </b-row>
        </section>
      </b-col>
      <b-col cols="6">
        <section id="widget-preview-section">
          <LmWidget
            v-if="widgetType"
            :component="component"
            :widget="widget"
          />
          <div v-else>
            <LmSvgIcon
              icon="LmSettingsIcon"
              width="18em"
              wrapperClass="my-4 d-flex align-items-center flex-column"
              text="Selecciona una tipo de Widget para comenzar a configurarlo"
            />
          </div>
        </section>
      </b-col>
    </b-row>
  </main>
</template>

<script>
// Utils
import commonsApi from '@/api/commons'
import { getWidgetProps } from '@/helpers/LmWidgets'
import lmToasts from '@/mixins/lmToasts.js'

// Components
import LmSelect from '@/components/form/elements/LmSelect'
import LmButton from '@/components/form/elements/LmButton'
import LmWidget from '@/components/LmWidget'

// Builder Components
import LmListBuilder from '@/components/widgets/builders/LmListBuilder'
import LmTitleBuilder from '@/components/widgets/builders/LmTitleBuilder'

export default {
  mixins: [lmToasts],
  props: {
    isOnEditMode: {
      type: Boolean,
      default: false
    },
    optionsPath: {
      type: String,
      default: ''
    },
    pathToRedirectOnCancel: {
      type: String,
      default: ''
    }
  },
  components: {
    LmSelect,
    LmButton,
    LmWidget,
    LmListBuilder,
    LmTitleBuilder
  },
  data () {
    return {
      isLoading: false,
      widget: {},
      widgetType: '',
      widgetTypesSelected: '',
      widgetTypesOptions: {
        disabledOption: 'Seleccione una opción',
        content: []
      }
    }
  },
  computed: {
    component () {
      return this.widgetType.replace('Builder', '')
    }
  },
  methods: {
    onSelectWidgetType (event) {
      this.widget = getWidgetProps(event)
      this.widgetType = event
    },
    async onSave () {
      try {
        this.isLoading = true
        const widget = {
          name: this.widget.name,
          properties: {
            ...this.widget
          },
          component: this.component
        }
        if (this.isOnEditMode) {
          const res = await commonsApi.axiosPutWrapper(`/widgets/${this.$route.params.id}`, widget)
          this.lmToastSuccessMessage(`Se editó ${res?.data?.name || ' el widget'} correctamente.`, 'Se guardó exitosamente')
        } else {
          const res = await commonsApi.axiosPostWrapper('/widgets', widget)
          this.lmToastSuccessMessage(`Se creó ${res?.data?.name || ' el widget'} correctamente.`, 'Se guardó exitosamente')
        }
        setTimeout(() => {
          this.isLoading = false
          this.$router.push(this.pathToRedirectOnCancel)
        }, 650)
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = true
      }
    },
    onCancel () {
      this.$router.push(this.pathToRedirectOnCancel)
    },
    async onDelete () {
      try {
        this.isLoading = true
        const res = await commonsApi.axiosPutWrapper(`/widgets/delete/${this.$route.params.id}`)
        this.lmToastSuccessMessage(`Se eliminó ${res?.data?.name || ' el widget'} correctamente.`, 'Se eliminó exitosamente')
        setTimeout(() => {
          this.isLoading = false
          this.$router.push(this.pathToRedirectOnCancel)
        }, 650)
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    }
  },
  async created () {
    try {
      this.isLoading = true
      // Cargo todos los widgets como opciones
      if (this.optionsPath) {
        const options = await commonsApi.axiosGetWrapper(this.optionsPath)
        for (const group in options.data.widgets) {
          this.widgetTypesOptions.content.push(options.data.widgets[group])
        }
      }

      // Cargo el widget en modo edición
      if (this.isOnEditMode) {
        const widget = await commonsApi.axiosGetWrapper(`/widgets/${this.$route.params.id}`)
        this.widget = widget.data.properties
        this.widgetType = `${widget.data.component}Builder`
        this.widgetTypesSelected = `${widget.data.component}Builder`
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>

<style>

</style>
